import { SxProps, Theme } from '@mui/material'

/**
 * Secondary brand coral used for Cancel / dismiss buttons across the admin
 * cards, so they're clearly distinct from the blue Save / Create buttons.
 */
export const cancelButtonSx: SxProps<Theme> = {
  backgroundColor: '#fa7861',
  '&:hover': { backgroundColor: '#e85d44' },
  '&.Mui-disabled': { backgroundColor: 'rgba(0, 0, 0, 0.12)' },
}

/** Coral used for archive (soft-delete) icon buttons in the admin tables. */
export const archiveIconSx: SxProps<Theme> = { color: '#fa7861' }
